<template>
  
    <basic-container>
        <el-form label-width="100px" inline>
          <el-form-item label="项目名称" required valid="projectId">
            <el-select v-model="editFormData.projectId" @change="handleProjectIdChange">
              <el-option
                  v-for="(item,index) in projectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
              >

              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划名称" required valid="name">
            <el-input v-model="editFormData.name"></el-input>
          </el-form-item>
          <el-form-item label="计划日期" required valid="dateRange">
              <el-date-picker
                v-model="editFormData.dateRange"
            value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
                </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="计划类型">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="巡检班组">
            <el-input></el-input>
          </el-form-item> -->
        </el-form>
        <el-form label-width="100px" inline>
            <!-- <el-form-item label="巡检班组" valid="groupId">
              <el-select v-model="addInspectPlanForm.groupId" validname="班组名称" @change="handleProjectIdChange">
                <el-option
                    v-for="(item,index) in groupLidt"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="巡检人" valid="handerId">
              <avue-input-tree  v-model="editFormData.planInspectManId" placeholder="请选择巡检人"  :dic="handleIdList"></avue-input-tree>

              <!-- <el-select v-model="editFormData.planInspectManId" validname="巡检人" @change="planInspectManIdChange">
                <el-option
                    v-for="item in handleIdList"
                    :key="item"
                    :label="item.realNameAndPhone"
                    :value="item.id"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
        </el-form>
        <el-form label-width="100px">
          <el-form-item label="巡检周期" required valid="inspectCycleType">
            <el-radio-group v-model="editFormData.inspectCycleType" @change="handleCycleTypeChange">
              <el-radio :label="1">天</el-radio>
              <el-radio :label="2">周</el-radio>
              <el-radio :label="3">月</el-radio>
              <el-radio :label="4">自定义</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="具体时间" required v-if="editFormData.inspectCycleType==2" valid="detailDate">
            <div v-if="editFormData.inspectCycleType==2" name="周">
              <el-checkbox-group v-model="editFormData.detailDateList" v-if="editFormData.detailDateList">
                <el-checkbox label="1">周一</el-checkbox>
                <el-checkbox label="2">周二</el-checkbox>
                <el-checkbox label="3">周三</el-checkbox>
                <el-checkbox label="4">周四</el-checkbox>
                <el-checkbox label="5">周五</el-checkbox>
                <el-checkbox label="6">周六</el-checkbox>
                <el-checkbox label="7">周日</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="具体时间" required v-if="editFormData.inspectCycleType==3" valid="detailDateList">
            <div v-if="editFormData.inspectCycleType==3" name="月份">
              <el-checkbox-group v-model="editFormData.detailDateList" v-if="editFormData.detailDateList">
                <el-checkbox label="1"></el-checkbox>
                <el-checkbox label="2"></el-checkbox>
                <el-checkbox label="3"></el-checkbox>
                <el-checkbox label="4"></el-checkbox>
                <el-checkbox label="5"></el-checkbox>
                <el-checkbox label="6"></el-checkbox>
                <el-checkbox label="7"></el-checkbox>
                <el-checkbox label="8"></el-checkbox>
                <el-checkbox label="9"></el-checkbox>
                <el-checkbox label="10"></el-checkbox>
                <el-checkbox label="11"></el-checkbox>
                <el-checkbox label="12"></el-checkbox>
                <el-checkbox label="13"></el-checkbox>
                <el-checkbox label="14"></el-checkbox>
                <el-checkbox label="15"></el-checkbox>
                <el-checkbox label="16"></el-checkbox>
                <el-checkbox label="17"></el-checkbox>
                <el-checkbox label="18"></el-checkbox>
                <el-checkbox label="19"></el-checkbox>
                <el-checkbox label="20"></el-checkbox>
                <el-checkbox label="21"></el-checkbox>
                <el-checkbox label="22"></el-checkbox>
                <el-checkbox label="23"></el-checkbox>
                <el-checkbox label="24"></el-checkbox>
                <el-checkbox label="25"></el-checkbox>
                <el-checkbox label="26"></el-checkbox>
                <el-checkbox label="27"></el-checkbox>
                <el-checkbox label="28"></el-checkbox>
                <el-checkbox label="29"></el-checkbox>
                <el-checkbox label="30"></el-checkbox>
                <el-checkbox label="31"></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="巡视开始时间" required v-if="editFormData.inspectCycleType==4" valid="inspectBeginTime">

            
          <el-date-picker
            v-model="editFormData.inspectBeginTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
            <!-- <el-input v-model="addForm.inspectBeginTime"></el-input> -->
          </el-form-item>
          <el-form-item label="巡检天数" required v-if="editFormData.inspectCycleType==4" valid="inspectCycle">
            <el-input v-model="editFormData.inspectCycle"></el-input>
          </el-form-item>
          <el-form-item label="周期休息天数（天）" required v-if="editFormData.inspectCycleType==4" valid="intervalTime">
            <el-input v-model="editFormData.intervalTime"></el-input>
          </el-form-item>
              <!-- v-show="inspectplanAddForm.groupId" -->
          <el-form-item label="时间段" required valid="timeQuantum">
            
            <select-time
            v-if="selectTimeFlag"
            v-model="editFormData.timeQuantum"
              :selectedTime="selectedTime"
              :quantumTime="quantumTime"
              @getTime="getTime"
              ref="selectTimeAdd"
            >
            </select-time>
          </el-form-item>
        </el-form>
        <el-form label-width="100px">
          <el-form-item label="巡检说明" required valid="remark">
            <el-input v-model="editFormData.remark" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="巡检路线" required valid="dateRange">
            <div>
              <div>
                <el-button 
                type="primary"
                   size="small"
                   icon="el-icon-plus"
                   @click="addInspectLine"
                >
                  新增
                </el-button>
              </div>
              <el-table :data="inspectLineList">
                <el-table-column
                    label="排序"
                    type="index"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="deviceName"
                    label="设备名称"
                  >
                  </el-table-column>
                  <!-- <el-table-column
                    prop="remark"
                    label="位置"
                  >
                  </el-table-column> -->
                  <el-table-column
                    prop="standardNames"
                    label="巡检标准"
                  >
                  </el-table-column>
                  <el-table-column
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <!-- <el-button type="text" @click="editHandler(scope.row)">编辑</el-button> -->
                      <el-button type="text" @click="deleteHandler(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item>
          </el-form-item>
        </el-form>
    <el-dialog
        title="新增巡检路线"
        :visible.sync="dialogInspectLineCreateBoxVisible"
        append-to-body>
        <el-form label-width="100px">
          <el-form-item label="设备名称" required>
            <el-select 
              filterable
              v-model="inspectForm.deviceId"
              @change="handleDeviceChange"
            >
              <el-option
                  v-for="(item,index) in deviceList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
              >
<span style="float: left">{{ item.code?item.name+'-'+item.code:item.name }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.areaName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="位置">

          </el-form-item> -->
          <el-form-item label="巡检标准" required>
              <el-select 
                v-model="inspectForm.standardIds"
                @change="handleStandardChange"
                multiple
                >
                    <el-option
                        v-for="(item,index) in standardList"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                    >

                    </el-option>
                </el-select>
          </el-form-item>
          <el-form-item>
                      <el-button type="primary" @click="saveInspectLineHandler">保存</el-button>
                      <el-button @click="dialogInspectLineCreateBoxVisible=false">取消</el-button>
          </el-form-item>       
        </el-form>
    </el-dialog>
    <div style="width:100%;text-align:center;padding-bottom: 2rem;">
        <el-button type="primary" @click="submitInspectAddFrom">
            提交
        </el-button>
        <el-button @click="cancelInspectAddFrom">
            取消
        </el-button>
    </div>
      </basic-container>
</template>

<script>
  import selectTime from "./select-time";
  import {getDeviceList, getStandardList, saveInspectPlan, updateInspectPlan, getDetail} from "@/api/crmedical/device/deviceinspectplan";
  import {getProjectList,getGroupListByModuleType} from "@/api/crmedical/group/group";
  
export default {
  // props: ['editFormData'],
  props:{
    editFormData:{
      type:Object,
      default:{}
    }
  },
  components: {
    'select-time': selectTime,
  },
  watch:{
    editFormData(){
      console.log('editFormData==>',this.editFormData);
      this.getGroupListByModuleType(this.editFormData.projectId)
    }
  },
    data(){
        return{
          handleIdList:[],
          selectedList:[],
            standardList:[],
            selectTimeFlag:false,
            tempProjectId:'',
        inspectLineList:[],
        inspectForm:{},
        selectedTime:[],
        quantumTime:[],
        dialogInspectLineCreateBoxVisible:false,
            // editFormData:{
            //     inspectCycleType:1,
            //     detailDate:[],
            // },

addInspectPlanFormRules:[
                'inspectCycleType',
                // 'detailDateList',
                'projectId',
                'name',
                'dateRange',
                'timeQuantum',
                'remark'
            ],
            formLabelKey:{
                inspectCycleType:'巡检周期类型',
                detailDateList:'具体时间',
                projectId:'项目名称',
                name:'计划名称',
                dateRange:'计划日期',
                timeQuantum:'时间段',
                remark:'巡检说明',
                inspectBeginTime:'巡视开始时间',
                inspectCycle:'巡检天数',
                intervalTime:'周期休息天数（天）'
            },
            formElement:{
                inspectCycleType:'selecat',
                detailDateList:'checkbox',
                projectId:'input',
                name:'input',
                dateRange:'input',
                timeQuantum:'时间段',
                remark:'巡检说明',
                planInspectManId:'',
            },


            inspectCycleType:1,
            deviceList:[],
            projectList:[],
        }
    },
    created(){
      console.log('1231111==>',123);
      getDetail({id:this.editFormData.id}).then((res)=>{
        console.log(res);
        this.editFormData = res.data;
        this.editFormData.devices = res.data.devices;
        this.editFormData.remark = res.data.remark;
        // this.editFormData.detailDateList = res.data;
        this.inspectLineList = res.data.devices;



      console.log(this.editFormData);
      this.editFormData.dateRange = [this.editFormData.planBeginTime,this.editFormData.planEndTime];
      if(this.editFormData.timeQuantum){
        let timeQuantumList = this.editFormData.timeQuantum.split(',');
        // this.selectedTime = timeQuantumList;
        this.selectedTime = [];
        timeQuantumList.forEach((el,i)=>{
          this.selectedTime.push(el);
          let timeRange = el.split('+')[0];
          let days = el.split('+')[1];
          let start = timeRange.split('~')[0];
          let end = timeRange.split('~')[1];
          console.log(days);
          this.quantumTime.push({
            start:start,
            end:end,
            days:days
          });
        });
      }
      console.log("this.editFormData.detailDate===>",this.editFormData.detailDate);
      if(this.editFormData.detailDate){

        this.editFormData.detailDateList = this.editFormData.detailDate.split(',');

      }
      console.log('this.editFormData.detailDateList===>',this.editFormData.detailDateList);

        this.tempProjectId = this.editFormData.projectId

          console.log('this.editFormData.inspectCycleType====>',this.editFormData.inspectCycleType);
          if(this.editFormData.inspectCycleType == 1){
            // this.editFormData.detailDateList = ['1'];
            this.editFormData = Object.assign({}, this.editFormData,{'detailDateList':['1']})
        
          }
                this.editFormData = Object.assign({}, this.editFormData,{'dateRange':[this.editFormData.planBeginTime,this.editFormData.planEndTime]})
    
      });
        getProjectList().then((res)=>{
            console.log(res);
            this.projectList = res.data;
            // this.addGroupForm.projectId = this.projectList[0].id;
        });
        getDeviceList({projectId:this.tempProjectId}).then((res)=>{
          console.log(res);
                      res.data.forEach((ele,index)=>{
                        ele.name = ele.name+'-'+ele.code
                      });
          this.deviceList = res.data;
        });
    },
    mounted(){
        // setTimeout(()=>{

            this.selectTimeFlag = true;
        // },1000)
    },
    methods:{
        cancelInspectAddFrom(){
            this.$emit('closeEditForm');
        },
        submitInspectAddFrom(){
            if(this.editFormData.dateRange){
                this.editFormData.planBeginTime = this.editFormData.dateRange[0]
                this.editFormData.planEndTime = this.editFormData.dateRange[1]
            }
            
            console.log(this.editFormData.detailDate);
            if(this.editFormData.detailDateList){
                this.editFormData.detailDate = this.editFormData.detailDateList.join(',');
            }
            // console.log(this.selectedTime);
            console.log(this.editFormData);
            console.log(this.inspectLineList);
            console.log(this.inspectForm);
            if(this.inspectLineList){
              this.editFormData.devices = [];
              this.inspectLineList.forEach((e,i)=>{
                this.editFormData.devices.push({
                  standardIds:e.standardIds instanceof Array?e.standardIds.join(','):e.standardIds,
                  deviceId:e.deviceId
                })
              });
            }

            let validkeysList = this.addInspectPlanFormRules;
            // let validkeysList = Object.keys(this.editFormData);
            // Object.keys(this.addInspectPlanForm)
            // let valuesList = Object.values(this.editFormData)
            let valuesList = [];
            validkeysList.forEach((e)=>{
              valuesList.push(this.editFormData[e]);
            })
            console.log("validkeysList,valuesList=========>",validkeysList,valuesList);
            // if(this.editFormData.inspectCycleType == 1){

            // }else{

              let validBlock = this.commonValid(validkeysList,valuesList);
            // }
            let validBlock_ = false;
            let _validBlock_ = false;
              let re = /^[0-9]+$/ ;
            if(this.editFormData.inspectCycleType == 4){
                validBlock_ = this.commonValid(['inspectBeginTime','inspectCycle','intervalTime'],
                [this.editFormData.inspectBeginTime,this.editFormData.inspectCycle,this.editFormData.intervalTime],
                re
              );
            }
            if(this.editFormData.inspectCycleType == 2 || this.editFormData.inspectCycleType == 3 ){

                if(!this.editFormData.detailDateList || this.editFormData.detailDateList.length==0){
                    _validBlock_ = true;
                    this.$message.error(`"具体时间"不能为空!`);
                    return;
                }
                // validBlock_ = this.commonValid(['inspectBeginTime','inspectCycle','intervalTime'],[this.editFormData.inspectBeginTime,this.editFormData.inspectCycle,this.editFormData.intervalTime]);
            }
            if(this.inspectLineList.length==0){
                    this.$message.error(`"巡检路线"不能为空!`);
                    return;
            }
            if(validBlock || validBlock_){
                return;
            }
            if(this.editFormData.inspectCycleType == 4){
                if(!re.test(this.editFormData.inspectCycle)){
                  this.$message.error('"巡检天数"格式错误!');
                  return;
                }
                if(!re.test(this.editFormData.intervalTime)){
                  this.$message.error('"周期休息天数（天）"格式错误!');
                  return;
                }
            }
            updateInspectPlan(this.editFormData).then((res)=>{
              console.log(res);
              this.$message.success(res.msg);
              this.$emit('closeEditForm');
            });
        },


        commonValid(keysList,valuesList,re){
            let validBlock = false;
            // let tempValidItem = 
            console.log(keysList);
            keysList.forEach((ele,index)=>{
                this.clearValidStyle(ele)
            });
            keysList.forEach((ele,index)=>{
                // this.clearValidStyle(ele)
                if(!valuesList[index]){
                    validBlock = true;
                    this.setValidStyle(ele,this.formLabelKey,re);
                }
            });
            return validBlock;

        },
        setValidStyle(ele,formLabelKey){
            // setTimeout(()=>{
                if(ele==='timeQuantum'||ele==='detailDate'||ele==='detailDateList'||ele==='devices'){

                }else if(ele==="remark"){
                    console.log("ele==>",ele);
                    console.log(document.querySelector(`div[valid=${ele}]`).querySelector('textarea'));
                    document.querySelector(`div[valid=${ele}]`).querySelector('textarea').style.border = '1px solid red';
                }else{
                    console.log("ele==>",ele);
                    console.log(document.querySelector(`div[valid=${ele}]`).querySelector('input'));
                    document.querySelector(`div[valid=${ele}]`).querySelector('input').style.border = '1px solid red';

                }
            setTimeout(()=>{
              console.log('setTimeout===============');
                this.$message.error(`"${this.formLabelKey[ele]}"不能为空!`);
            },600);
        },
        clearValidStyle(ele){
            console.log('clearValidStyle==>'+ele);
            // setTimeout(()=>{
                if(ele==='timeQuantum'||ele==='detailDate'||ele==='detailDateList'||ele==='devices'){

                }else if(ele==="remark"){
                    
                    console.log("ele==>",ele);
                    console.log(document.querySelector(`div[valid=${ele}]`).querySelector('textarea'));
                    document.querySelector(`div[valid=${ele}]`).querySelector('textarea').style.border = '';
                }else{
                    // if(inspectCycleType){
                        console.log("ele==>",ele);
                        console.log(document.querySelector(`div[valid=${ele}]`).querySelector('input'));
                        document.querySelector(`div[valid=${ele}]`).querySelector('input').style.border = '';
                    // }

                }
                // this.$message.error(`"${this.formLabelKey[ele]}"不能为空!`);
            // },500);
        },


        handleProjectIdChange(val){
            this.tempProjectId = val;
            this.addInspectPlanForm.planInspectManId = ''
            this.getGroupListByModuleType(val);
        },
        planInspectManIdChange(val){
          this.addInspectPlanForm.planInspectManId = val
        },
      getGroupListByModuleType(projectId){
        console.log('123==>',123);
        getGroupListByModuleType({projectId:projectId,moduleType:9}).then(res=>{
          console.log('res getGroupListByModuleType==>',res);
          res.data.forEach(item=>{
            item.label = item.realNameAndPhone;
            item.value = item.userId;
          })
          this.handleIdList = res.data;
        })
      },
      handleDeviceChange(val){
        
        // getDeviceList().then((res)=>{
        //   console.log(res);
        //   this.deviceList = res.data;
        // });
        // console.log('8888');
        this.inspectForm.standardIds = [];
        this.deviceList.forEach((ele,index)=>{
          if(ele.id === val){
            this.inspectForm.deviceName = ele.name;
          }
        });
        getStandardList({deviceId:val}).then((res)=>{
            // console.log(res);
            this.standardList = res.data
        });
      },
      handleStandardChange(val){
        console.log('8888');
        this.inspectForm.standardNames = [];
        console.log(this.inspectForm.standardIds,this.standardList);
        this.standardList.forEach((ele,index)=>{
          this.inspectForm.standardIds.forEach((el,i)=>{
            if(ele.id === el){
              this.inspectForm.standardNames.push(ele.name);
            }
          });
        });
        console.log(this.inspectForm.standardNames);
        // getStandardList({deviceId:val}).then((res)=>{
        //     // console.log(res);
        //     this.standardList = res.data
        // });
      },
      addInspectLine(){
          getDeviceList({projectId:this.tempProjectId}).then((res)=>{
          console.log(res);
                      res.data.forEach((ele,index)=>{
                        ele.name = ele.name+'-'+ele.code
                      });
          this.deviceList = res.data;
        });
        this.dialogInspectLineCreateBoxVisible = true;
      },
      saveInspectLineHandler(){

        let selectBlock = false;
        if(!this.inspectForm.deviceId){
          this.$message.error('请选择巡检设备！');
          return;
        }
        if(!this.inspectForm.standardIds||this.inspectForm.standardIds.length==0){
          this.$message.error('请选择巡检标准！');
          return;
        }
        if(this.inspectLineList&&this.inspectLineList.length>0){
          this.inspectLineList.forEach((ele,index)=>{
            if(this.inspectForm.deviceId === ele.deviceId){
              selectBlock = true;
            }
          });
        }

        if(selectBlock){
          this.$message.error('巡检设备有重复！');
          return;
        }

        this.inspectLineList.push({
            deviceName:this.inspectForm.deviceName,
            deviceId:this.inspectForm.deviceId,
            standardIds:this.inspectForm.standardIds,
            standardNames:this.inspectForm.standardNames?this.inspectForm.standardNames.join(','):'',
            });
        this.dialogInspectLineCreateBoxVisible = false;
      },
      handleCycleTypeChange(val){
        // this.editFormData.detailDateList = [];
        
            this.editFormData = Object.assign({}, this.editFormData,{'detailDateList':['1']})
        this.editFormData.detailDate = [];
        this.editFormData.inspectCycleType = val;
      },
        // 获得时间选择器传来的值
        getTime(time) {
        // this.inspectplanAddForm.timeQuantum = time;
            console.log(time);
            if(time){
                let timeList = [];
                time.forEach((ele,index)=>{
                    timeList.push(ele.time);
                })
                this.editFormData.timeQuantum = timeList.join(',');
            }
        },
        deleteHandler(row){
            this.inspectLineList.forEach((ele,index)=>{
                if(row.deviceId===ele.deviceId){
                    this.inspectLineList.splice(index,1);
                }
            });
        },
    }
}
</script>

<style>

</style>